export default "__VITE_ASSET__CR0T97NW__"